export enum LoadingState {
  NotLoaded,
  Loading,
  Loaded,
  Removed,
}
